"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateOttMappingDto = instanceOfCreateOttMappingDto;
exports.CreateOttMappingDtoFromJSON = CreateOttMappingDtoFromJSON;
exports.CreateOttMappingDtoFromJSONTyped = CreateOttMappingDtoFromJSONTyped;
exports.CreateOttMappingDtoToJSON = CreateOttMappingDtoToJSON;
exports.CreateOttMappingDtoToJSONTyped = CreateOttMappingDtoToJSONTyped;
/**
 * Check if a given object implements the CreateOttMappingDto interface.
 */
function instanceOfCreateOttMappingDto(value) {
    if (!('sport_id' in value) || value['sport_id'] === undefined)
        return false;
    if (!('league_id' in value) || value['league_id'] === undefined)
        return false;
    if (!('ott_platform_id' in value) || value['ott_platform_id'] === undefined)
        return false;
    return true;
}
function CreateOttMappingDtoFromJSON(json) {
    return CreateOttMappingDtoFromJSONTyped(json, false);
}
function CreateOttMappingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sport_id': json['sport_id'],
        'league_id': json['league_id'],
        'ott_platform_id': json['ott_platform_id'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}
function CreateOttMappingDtoToJSON(json) {
    return CreateOttMappingDtoToJSONTyped(json, false);
}
function CreateOttMappingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sport_id': value['sport_id'],
        'league_id': value['league_id'],
        'ott_platform_id': value['ott_platform_id'],
        'priority': value['priority'],
    };
}
